/**
 * The Users page filtered to the people holding a role, in the address form Refine's table
 * reads (the Users page sends it to the sign-in service as `?role=<role name>`). The sign-in
 * service counts a role's users by the same role name, so the number and the list agree, except
 * for a person given the same role twice (the Roles list counts each assignment) and roles that
 * share a name across companies (both the count and the list pool them).
 */
export const usersWithRolePath = (roleName: string) =>
  `/users?filters[0][field]=role&filters[0][operator]=eq&filters[0][value]=${encodeURIComponent(roleName)}`;
